module.exports = __webpack_public_path__ + "assets/img/mobileEnter.c0e326e0.png";